module.exports = __webpack_public_path__ + "img/solution-preevision2x-strength-pic.cf85e7ab.png";